const Reporting = () => {
  return (
    <div>
      <h1>Reporting</h1>
    </div>
  );
};

export default Reporting;
